
import CheckboxInput from "./form/Checkbox.vue";
import { tags } from "@book-searcher/data";
import { defineComponent, ref, onUnmounted } from "vue";
export default defineComponent({
  name: "Tags",
  components: {
    CheckboxInput,
  },
  props: {
    modelValue: {
      type: Object as () => string[],
    },
  },
  setup() {
    const checkedTags = ref([]);
    const tagsOpen = ref(false);
    const isTagsShow = ref(window.innerWidth > 700);

    const handleShowTags = () => {
      isTagsShow.value = window.innerWidth > 700;
    };

    window.addEventListener("resize", handleShowTags);

    onUnmounted(() => {
      window.removeEventListener("resize", handleShowTags);
    });

    return { checkedTags, tags, tagsOpen, isTagsShow };
  },
});
